














import { Component, Mixins, Prop } from "vue-property-decorator";
import { ISize } from "../../../../../../domain/drawing";
import { instanceOfIWizardSizeSpecifiable } from "../../../../../../domain/format";
import { ContentContainerMixin } from "./mixins";

@Component({
  components: {
    WizardContent: () => import("./WizardContent.vue"), // 再帰的に呼ばれるコンポーネントは動的import要.(単一コンポーネントでの再帰ならname指定でも回避可能？)
  },
})
export default class WizardContentStackContainer extends Mixins(ContentContainerMixin) {
  @Prop()
  scale: number;

  get size(): ISize<string> {
    return (instanceOfIWizardSizeSpecifiable(this.content) && this.content.size)
      ? this.content.size
      : {
        width: "50vmin",
        height: "50vmin",
      };
  }
}
